import React, { PropsWithChildren } from "react";
import Button from "components/utils/Button";
import { ButtonSize, Color } from "utils/types/util.types";
import { phone } from "utils/constants/constants";
import { useScreenSize } from "utils/hooks/useScreenSize";
import { isNotNull } from "utils/types/typeguards";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

type Props = {
	buttonSize?: ButtonSize
}

function TelButton({
	children,
	buttonSize,
}: PropsWithChildren<Props>) {

	const screenSize = useScreenSize();

	const { t } = useTranslation();

	const { enqueueSnackbar } = useSnackbar();

	const getButtonSize = () => {
		if (isNotNull(buttonSize)) return buttonSize;
		return screenSize.width > 678 ? ButtonSize.LARGE : ButtonSize.SMALL;
	}

	const onClick = () => {
		enqueueSnackbar(t("snackbar.copyMessage.phone"), { variant: "success", preventDuplicate: true })
		navigator.clipboard.writeText(phone)
	}

	return (
		<Button
			color={ Color.BLUE }
			link={ `tel:${phone}` }
			size={ getButtonSize() }
			onClick={ onClick }
			tooltip={ { id: "contact-modal-button-tel-tooltip", message: phone } }
		>
			{ children }
		</Button>
	);
}

export default TelButton;